import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { AdviserWizardDispatcher } from "./Variable";
import { ResultPageModel } from "../../../../Wrap/Core/SortingAndPaging/Models/ResultPageModel";
import { Adviser } from "../../../../Wrap/Models/Domains/Adviser/Adviser";

export interface AdviserWizardStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: ResultPageModel<Adviser>;
}

export class AdviserWizardStoreStatic extends BaseStore<AdviserWizardStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AdviserWizardDispatcher, (actionData) =>
            this.onAdviserWizardStoreResponse(actionData)
        );
    }

    public getLastResult(): AdviserWizardStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AdviserWizardStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onAdviserWizardStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
